<template>
  <ReportAgent :urls="urls" :mandatory-filter="false" />
</template>

<script>
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import ReportAgent from "@/own/components/reports/ReportAgent";
export default {
  name: "StockVariance",
  components: { ReportAgent },
  data: () => ({
    urls: {
      data_url: "/reports/reportStockVariance",
      show_url: "/reports/reportStockVariance/show",
    },
  }),
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
  },
};
</script>
